import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as Types from 'types'
import { Card, ProfileCompletionBar } from 'components'
import { selectors as globalSelectors } from 'global-reducer'
import { buildBarModel } from '../../profile/profile-completion-sections'

const propTypes = {
  artist: Types.artist.isRequired,
  currentSchoolYearId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

const defaultProps = {
  currentSchoolYearId: null,
}

function ProfileCompletionCard({ artist, currentSchoolYearId }) {
  const [, setBarVersion] = useState(0)

  useEffect(() => {
    const onProfileCompletionUpdated = () => {
      setBarVersion((prev) => prev + 1)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'artist-profile-completion-updated',
        onProfileCompletionUpdated
      )
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'artist-profile-completion-updated',
          onProfileCompletionUpdated
        )
      }
    }
  }, [])

  const { sections, completedSections, percent } = buildBarModel(artist, {
    currentSchoolYearId,
  })

  return (
    <Card>
      <ProfileCompletionBar
        variant="card"
        percent={percent}
        completedSections={completedSections}
        sections={sections}
      />
    </Card>
  )
}

ProfileCompletionCard.propTypes = propTypes
ProfileCompletionCard.defaultProps = defaultProps

function mapStateToProps(state) {
  const currentSchoolYear = globalSelectors.currentSchoolYear(state)
  return {
    currentSchoolYearId: currentSchoolYear ? currentSchoolYear.id : null,
  }
}

export default compose(connect(mapStateToProps))(ProfileCompletionCard)
